import { log } from "@/utils/logs";

export function setUser (state, payload) {
  state.flatmap[payload.id] = payload;
  state.currentUser = state.flatmap[payload.id];
  log("MUTATION: setUser::", "Done");
}

export function setProfile (state, payload) {
  state.flatmap[payload.student.id] = payload.student;
  state.profile = state.flatmap[payload.student.id];
  log("MUTATION: setProfile::", "Done");
}

export function removeUserState (state) {
  // console.log("removeUserState");
  state.currentUser = null;
}

export function removeUserProfile (state) {
  // console.log("removeUserProfile");
  state.profile = null;
}
